import { render, staticRenderFns } from "./team-page.vue?vue&type=template&id=833f0e30&"
import script from "./team-page.vue?vue&type=script&lang=js&"
export * from "./team-page.vue?vue&type=script&lang=js&"
import style0 from "./team-page.vue?vue&type=style&index=0&id=833f0e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports